<template>
  <div class="filter-set">
    <div class="filter-header">
      <div class="filter-header__inner">
        <div class="item-count">
          {{ itemCount }} {{ countLabel }}
        </div>
        <div>
          <button
            type="button"
            :class="{'toggle': true, 'active': drawerOpen}"
            @click="toggleDrawer"
          >
            <span>Filter</span>
          </button>
          <label for="sort-by">Sorty By</label>
          <select
            id="sort-by"
            v-model="sortSelected"
            name="sort-by"
            class="select-css"
            @change="changeSort($event)"
          >
            <option
              v-if="view == 'trends' || view == 'recipes'"
              value="newest"
            >
              Newest
            </option>
            <option
              v-if="view == 'trends' || view == 'recipes'"
              value="oldest"
            >
              Oldest
            </option>
            <option value="a-z">
              Sort A-Z
            </option>
            <option value="z-a">
              Sort Z-A
            </option>
          </select>
          <fieldset 
            v-if="buyNow != null && view !== 'buyNow'" 
            class="buy-now__check"
          >
            <input
              :id="buyNow.id"
              type="checkbox"
              :value="buyNow.id"
              :checked="buyNow.selected"
              :disabled="buyNow.disabled"
              @change="updateFilters"
            >
            <label :for="buyNow.id">Buy Now</label>
          </fieldset>
        </div>
        <button
          v-if="drawerOpen"
          class="close"
          @click="closeDrawer('X')"
        >
          <span>&times;</span>
        </button>
      </div>
    </div>
    <transition name="drawer">
      <div
        v-show="drawerOpen"
        class="filter-drawer"
      >
        <div class="filter-drawer__inner">
          <div
            v-for="(filterCategory) in filterCategories"
            :key="filterCategory"
            :class="{'filter-category': true, 'recipes': view == 'recipes'}"
          >
            <h3
              :class="{'active': categoriesOpen.includes(filterCategory)}"
              @click="showCat(filterCategory)"
            >
              <span>
                {{ filterCategory }}
              </span>
            </h3>
            <div
              :class="{'filter-group': true, 'active': categoriesOpen.includes(filterCategory)}"
            >
              <template
                v-for="(filt, index) in filtersInCategory(filterCategory)"
              >
                <fieldset
                  v-if="index < 6 || seeMoreState.includes(filt.id) || view == 'recipes'"
                  :key="filt.id"
                >
                  <input
                    :id="filt.id"
                    type="checkbox"
                    :checked="filt.selected"
                    :value="filt.id"
                    :disabled="filt.disabled"
                    @change="updateFilters"
                  >
                  <label :for="filt.id">{{ filt.name }}</label>
                </fieldset>
                <button
                  v-if="index === 6 && !seeMoreState.includes(filt.id) && view != 'recipes'"
                  :key="index"
                  class="see-more"
                  @click="seeMore(filt.id, filterCategory)"
                >
                  <span>
                    See More
                  </span>
                </button>
              </template>
            </div>
          </div>
        </div>
        <div class="filter-drawer__mobile-header">
          <!-- <div class="filter-drawer__back">
            <button
              type="button"
              class=""
              @click="closeDrawer('Back to')"
            >
              Back to {{ category }}
            </button>
          </div> -->
          <!-- <h3>{{ category }}: Filter</h3> -->
          <div class="filter-drawer__mobile-apply">
            <button
              type="button"
              class="button"
              @click="closeDrawer('Apply Filters')"
            >
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import { filter } from 'minimatch';


export default {
  name: "Filters",
  filters: {
      titleize(value){
          return value.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
      }
  },
  props: {
    remove: {
      type: Object,
      required: false,
      default: null
    },
    category: {
      type: String,
      required: false,
      default: 'Trends'
    },
    view: {
      type: String,
      required: true,
      default: 'trends'
    },
    itemCount: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: () => {
    return {
      currentFilterSets: [],
      drawerOpen: false,
      categoriesOpen: [],
      seeMoreState: [],
      sortSelected: 'a-z',
      filterArray: [],
      buyNow: null
    }
  },
  computed: {
    // category: function() {
    //   return window.filteringMode
    // },
    // currentFilterCategories: function() {
    //   let filterCats = []
    //   this.filters.map(k => {
    //     filterCats = Object.keys(k)
    //   })
    //   console.log('filterCats', filterCats)
    //   return filterCats
    // },
    // currentFilterSets: function() {
    //   let filterSets = []
    //   this.filters
    // }
    countLabel: function() {
      let title = '';
      if (this.view === 'merchandise') {
        title = 'item'
      } else {
        title = this.view
      }
      title = this.$options.filters.titleize(title);
      if (this.itemCount > 0 && this.view !== 'products' && this.view !== 'trends') {
        title = title + 's'
      }
      return title
    },
    filterCategories: function() {
      var categories = [];
      this.$store.state.filters.map(f => {
        if(categories.indexOf(f.categoryName) < 0 && f.id != '590'){
          // console.log(f.categoryName);
          categories.push(f.categoryName)
        }
      })
      // console.log('this.$store.state', this.$store.state)
      return categories;
    }
    
  },
  watch: {
    remove: function() {
      if (this.remove){
        this.removeFilters()        
        this.$emit('removed', null)
      }
    }
  
  },
  created()
    {
      const decodedQuery = decodeURI((this.$route.query.filters + '').replace(/\+/g, '%20'));
      const queryParams = decodeURI(decodedQuery)
      if (queryParams !== 'undefined'){
        let filters = queryParams.split(',');
        let numFilters = 0
        this.$store.state.filters.map(f => {
          
          if(filters.includes(f.id)){
            let payload = {
              value: f.id,
              checked: true
            }
            this.$store.dispatch('applyFilters', payload)
            this.filterArray.push(f.id)
            numFilters += 1
          }
        })
        if (numFilters === 0){
          this.$emit('noProductsFound', true)
        }
      }
      
    },
  mounted() {
      this.$store.state.filters.map(f => {
        if(f.id == '590'){
          this.buyNow = f
        }
      })
      this.sortSelected = (this.view === 'trends') ? 'newest' : 'a-z'
      this.changeSort();
    // this.makeFilterSets()
    // console.log('currentFiltersSets', this.currentFilterSets)
  },
  
  methods: {
      // console.log('filters', this.filters)
      // if(this.filters.length > 0) {
      //   let keys = []
      //   this.filters.forEach(f => {
      //     Object.keys(f).map(k => {
      //       if (!keys.includes(k)) {
      //         keys.push(k)
      //       }
      //     })
      //     f.forEach(x => {
      //       console.log('x', x)
      //     })
      //     console.log('keys', keys)
      //   })
      //   this.currentFilterSets = keys
      // }
    // },
    changeSort: function() {
          var sortBy = 'title'
          var sortDirection = 'ASC';
          switch(this.sortSelected) {
              case 'oldest':
                  sortBy = 'publishDate';
                  sortDirection = 'ASC';
                  break;
              case 'newest':
                  sortBy = 'publishDate';
                  sortDirection = 'DESC';
                  break;
              case 'a-z':
                  sortBy = 'title';
                  sortDirection = 'ASC';
                  break;
              case 'z-a':
                  sortBy = 'title';
                  sortDirection = 'DESC';
                  break;

          }
          this.$store.dispatch('applySort', {sortBy: sortBy, sortDirection: sortDirection});

          let label = 'sort: ' + sortBy + ' ' + sortDirection
          // console.log('label', label)
          // eslint-disable-next-line
          if (typeof dataLayer === 'object') {
            // eslint-disable-next-line
            dataLayer.push({
              event: 'genericEvent',
              eventCat: this.view + ' filter',
              eventAction: 'sort filter',
              eventLabel: label,
            });
          }
    },
    removeFilters() {
      let active = []
      this.$store.state.filters.filter(i => {
        if(i.selected){
          active.push(i.id)
        }
      })
      this.filterArray = active
      if(this.filterArray.length != 0){
        let appliedFilters = ''
        this.filterArray.forEach((filter, index) => {
          // console.log('filter: ', filter, ' | index: ', index)
          if (index == 0){
            appliedFilters += filter
          } else {
            appliedFilters += ',' + filter
          }
        })
        const encodedParams = encodeURI(appliedFilters);
        // const query = this.getQueryString()
        this.$router.push({path: this.$route.path, query: { filters: encodedParams }})
      } else {
        this.$router.replace({query: null})
      }
    },
    updateFilters: function(e) {
      console.log(e)
      // console.log('update', e.target.checked) // true = on
      // console.log('update', e.target.nextElementSibling.innerText)
      this.$store.dispatch('applyFilters', e.target)
      console.log('target', e.target)
      let action = e.target.checked ? 'select on' : 'select off'
      let label = e.target.nextElementSibling.innerText

      
      
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: this.view + ' filter',
          eventAction: action,
          eventLabel: label,
        });
      }

      if(action == 'select off'){
        this.removeFilters()
      } else {
        this.filterArray.push(e.target.id)
        let appliedFilters = ''
        this.filterArray.forEach((filter, index) => {
        // console.log('filter: ', filter, ' | index: ', index)
        if (index == 0){
          appliedFilters += filter
        } else {
          appliedFilters += ',' + filter
        }
      })
      const encodedParams = encodeURI(appliedFilters);
      // const query = this.getQueryString()
      this.$router.push({path: this.$route.path, query: { filters: encodedParams }})
      }
     
    },
   
    filtersInCategory: function(categoryName) {
      //console.log(categoryName);
      return this.$store.state.filters.filter(function (filterItem) {
        return filterItem.categoryName === categoryName
      })
    },
    toggleDrawer: function() {
      this.drawerOpen = !this.drawerOpen;
      let action = this.drawerOpen ? 'open filters' : 'close filters'
    
      // addPoints is for Easter Eggs 
      // uncomment when Easter Eggs is deployed.
      // window.addPoints('filter')


      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: this.view + ' filter',
          eventAction: action,
          eventLabel: action,
        });
      }
    },
    closeDrawer: function(from) {
      this.drawerOpen = false
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: this.view + ' filter',
          eventAction: 'close filters with ' + from,
          eventLabel: 'close filters',
        });
      }
    },
    showCat(cat) {
      if (this.categoriesOpen.includes(cat)) {
        let indexToRemove = this.categoriesOpen.indexOf(cat)
        this.categoriesOpen.splice(indexToRemove, 1)
      } else {
        this.categoriesOpen.push(cat)
      }
    },
    seeMore(filterId, filterCategory) {
      if (this.seeMoreState.includes(filterId)) {
        let indexToRemove = this.seeMoreState.indexOf(filterId)
        this.seeMoreState.splice(indexToRemove, 1)
      } else {
          var filts = this.filtersInCategory(filterCategory);
          for(var i = 0; i < filts.length; i++){
              this.seeMoreState.push(filts[i].id);
          }
      }
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: this.view + ' filter',
          eventAction: 'click',
          eventLabel: 'see more filters',
        });
      }
    }
  },
};
</script>